export default __webpack_public_path__ + "static/media/eye.30a23b53.svg";